import React from "react";
import DataGrid, {
  Column,
  Selection,
  FilterRow,
  Paging,
  Pager,
  Toolbar,
  Item,
  Lookup,
} from "devextreme-react/data-grid";
import { formatMessage } from "devextreme/localization";
import FileUploader from "devextreme-react/file-uploader";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { useScreenSize } from "../../../utils/media-query";
import notify from "devextreme/ui/notify";

import ToolbarBefore from "../../../components/toolbar-before/ToolbarBefore";
import ToolbarAfter from "./ToolbarAfter";
import {
  axios,
  ApprovalStatus,
  changeDisplayedName,
  RequestStatus,
  convertDateTime,
  generateBlobLink
} from "../../../common";

import PopupConfig from "../../../common/popup";

export default function OvertimeRegistrationTableList({
  middleware,
  dataGrid,
  renderActions,
  dataSource,
  handleChangeSelectBox,
  filter,
  setFilter,
  setIsLoading,
}) {
  const [errorPath, setErrorPath] = React.useState(null);
  const [file, setFile] = React.useState(null);
  const [clicked, setClicked] = React.useState(false);
  const { isXSmall, isSmall } = useScreenSize();
  const { handleOpenPopup, handleClosePopup, popupConfig } = PopupConfig();

  const handleImportExcel = async (e) => {
    if (clicked) return;
    setClicked(true);
    setIsLoading(true);
    try {
      if (!file) {
        notify("Please select file to import", "error", 3000);
        setIsLoading(false);
        setClicked(false);
        return;
      }
      const formData = new FormData();
      formData.append("fileName", file);
      const { headers, data } = await axios.post(
        "Overtime/ImportFile",
        formData,
        {
          responseType: "arraybuffer",
        }
      );
      setClicked(false);
      if (data.byteLength === 2) {
        notify("Import thành công", "success", 3000);
        handleChangeSelectBox();
        setIsLoading(false);
        handleClosePopup();
        return;
      }
      const relsUrl = generateBlobLink(data, headers["content-type"]);

      setErrorPath(relsUrl);
      notify(`Import đơn đăng ký không thành công`, "error", 3000);
      setIsLoading(false);
      handleChangeSelectBox();
    } catch (error) {
      var enc = new TextDecoder("utf-8");
      var arr = enc.decode(error.response.data);
      setIsLoading(false);
      notify(JSON.parse(arr).message, "error", 3000);
      setClicked(false);
    }
    // setOvertime(data.value);
  };
  const clearPopup = () => {
    setFile(null);
    setErrorPath(null);
    handleClosePopup();
    setClicked(false);
  };

  const renderViewPopup = () => {
    return (
      <Popup
        visible={popupConfig.popupVisible}
        onHiding={clearPopup}
        title={formatMessage("PopupTitle")}
        showTitle={true}
        width={isSmall || isXSmall ? "100%" : "550px"}
        height={isSmall || isXSmall ? "400px" : "400px"}
        borderRadius={10}
        closeOnOutsideClick={false}
      >
        <FileUploader
          selectButtonText="Select file"
          labelText=""
          accept=".xlsx, .xls"
          maxFileSize={5000000}
          uploadMode="useForm"
          onValueChanged={(e) => {
            // check file size and type
            if (e.value.length > 0) {
              if (e.value[0].size > 5000000) {
                notify("File size must be less than 5MB", "error", 3000);
                return;
              }
              if (
                e.value[0].type !==
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
                e.value[0].type !== "application/vnd.ms-excel"
              ) {
                notify("File type must be .xlsx or .xls", "error", 3000);
                return;
              }

              setFile(e.value[0]);
            }
          }}
        />
        {errorPath && (
          <div style={{ color: "red", marginTop: "10px" }}>
            <a href={errorPath} download="OvertimeRegistration.xlsx">
              Download Error File
            </a>
          </div>
        )}
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleImportExcel}
          options={{
            icon: "save",
            type: "success",
            text: formatMessage("Save"),
          }}
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={clearPopup}
          options={{
            icon: "close",
            type: "primary",
            text: formatMessage("Cancel"),
          }}
        />
      </Popup>
    );
  };
  return (
    <div>
      {popupConfig.popupVisible && renderViewPopup()}
      <DataGrid
        id="gridContainer"
        height={isXSmall || isSmall ? "auto" : document.documentElement.offsetHeight - 189}
        showBorders={true}
        showRowLines={true}
        hoverStateEnabled={true}
        rowAlternationEnabled={true}
        columnAutoWidth={true}
        columnResizingMode="widget"
        alignment="center"
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnHidingEnabled={true}
        ref={(e) => {
          dataGrid.current = e;
        }}
        dataSource={dataSource}
      >
        {/* <SearchPanel
      visible={true}
      width={240}
      className="datagrid-toolbar-search-panel"
      // placeholder={formatMessage("search")}
    /> */}
        <Selection
          mode="multiple"
          selectAllMode="page"
          showCheckBoxesMode="always"
        />
        <FilterRow visible={true} />
        <Paging defaultPageSize={10} />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[10, 20, 50, 100]}
          showInfo={true}
          visible={true}
        />
        {middleware && middleware.WriteState && (
          <Column
            caption={formatMessage("Action")}
            cellRender={renderActions}
            alignment="center"
          />
        )}
        <Column
          caption={formatMessage("EmployeeCode")}
          dataField="EmployeeCode"
          dataType="string"
        />
        <Column
          caption={formatMessage("EmployeeName")}
          dataField="FullName"
          dataType="string"
        />
        <Column
          caption={formatMessage("RequestStatus")}
          dataField="RequestStatus"
        >
          <Lookup
            dataSource={RequestStatus}
            displayExpr={changeDisplayedName()}
            valueExpr="id"
          />
        </Column>
        <Column
          caption={formatMessage("Date")}
          dataField="OvertimeDate"
          dataType="date"
          format="dd/MM/yyyy"
        />
        <Column
          caption={formatMessage("TotalHours")}
          dataField="TotalHours"
          dataType="string"
        />
        {/* <Column
          caption={formatMessage("IsBeforeShift")}
          dataField="IsBeforeShift"
          dataType="boolean"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        /> */}
        <Column
          caption={formatMessage("Shift")}
          dataField="ShiftInfo"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        />
        <Column
          caption={formatMessage("IsBreakTime")}
          dataField="IsBreakTime"
          dataType="boolean"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        />
        <Column
          caption={formatMessage("TimeIn")}
          dataField="TimeIn"
          dataType="time"
          format="HH:mm:ss"
        />
        <Column
          caption={formatMessage("TimeOut")}
          dataField="TimeOut"
          dataType="time"
          format="HH:mm:ss"
        />
        {/* <Column
          caption={formatMessage("HoursLate")}
          dataField="HoursLate"
          dataType="number"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        /> */}
        {/* <Column
          caption={formatMessage("TimeInLate")}
          dataField="TimeInLate"
          dataType="time"
          format="HH:mm:ss"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        />
        <Column
          caption={formatMessage("TimeOutLate")}
          dataField="TimeOutLate"
          dataType="time"
          format="HH:mm:ss"
          hidingPriority={isXSmall || isSmall ? 5 : false}
        /> */}
        <Column
          caption={formatMessage("Reason")}
          dataField="Reason"
          dataType="string"
        />
        <Column
          caption={formatMessage("Description")}
          dataField="Description"
          dataType="string"
        />
        <Column
          caption={formatMessage("CancelReason")}
          dataField="CancelReason"
          dataType="string"
        />
        <Column
          caption={formatMessage("CanceledDate")}
          dataField="CanceledDate"
          dataType="date"
          format="dd/MM/yyyy"
        />
        <Column
          caption={formatMessage("LastApprovalStatus")}
          dataField="LastApprovalStatus"
        >
          <Lookup
            dataSource={ApprovalStatus}
            displayExpr={changeDisplayedName()}
            valueExpr="id"
          />
        </Column>
        <Column
          caption={formatMessage("FirstApprovalName")}
          dataField="FirstApprovalName"
          dataType="string"
        />
        <Column
          caption={formatMessage("LastApprovalName")}
          dataField="LastApprovalName"
          dataType="string"
        />
        <Column
          caption={formatMessage("LastApprovalDate")}
          dataField="LastApprovalDate"
          dataType="date"
          format="dd/MM/yyyy"
          calculateCellValue={(e) => {
            if (e.LastApprovalDate === "0001-01-01T00:00:00Z") {
              return "";
            } else {
              return convertDateTime(e.LastApprovalDate);
            }
          }}
          width={120}
        />
        <Column
          caption={formatMessage("LastApprovalComments")}
          dataField="LastApprovalComments"
          dataType="string"
        />
        <Column
          caption={formatMessage("CreatedBy")}
          dataField="CreatedBy"
          hidingPriority={isXSmall || isSmall ? 5 : false}
        />
        <Column
          caption={formatMessage("CreatedDate")}
          dataField="CreatedDate"
          dataType="date"
          format="dd/MM/yyyy"
          hidingPriority={isXSmall || isSmall ? 5 : false}
        />
        <Column
          caption={formatMessage("UpdatedBy")}
          dataField="UpdatedBy"
          hidingPriority={isXSmall || isSmall ? 5 : false}
        />
        <Column
          caption={formatMessage("UpdatedDate")}
          dataField="UpdatedDate"
          dataType="date"
          format="dd/MM/yyyy"
          hidingPriority={isXSmall || isSmall ? 5 : false}
        />
        <Toolbar className="datagrid-toolbar-actions">
          <Item
            location="before"
            locateInMenu={isXSmall || isSmall ? "always" : "auto"}
            cssClass={"datagrid-toolbar-actions-dropdown"}
          >
            <ToolbarBefore
              middleware={middleware}
              filter={filter}
              setFilter={setFilter}
              handleChangeSelectBox={handleChangeSelectBox}
            />
          </Item>
          <Item
            location="after"
            locateInMenu={isXSmall || isSmall ? "always" : "auto"}
            cssClass={"datagrid-toolbar-actions-dropdown"}
          >
            <ToolbarAfter
              middleware={middleware}
              dataGrid={dataGrid}
              handleOpenPopup={handleOpenPopup}
            />
          </Item>
        </Toolbar>
      </DataGrid>
    </div>
  );
}
